import { Star, Quote } from "lucide-react";

const STATIC_REVIEWS = [
  { id: "rv1", name: "Rajesh Kumar", initials: "RK", location: "Hyderabad", rating: 5, quote: "Stayed for 3 weeks for a project at BIEC. Spotless rooms, helpful staff, walking distance to Metro. Felt like a second home." },
  { id: "rv2", name: "Priya Sharma", initials: "PS", location: "Mumbai", rating: 5, quote: "Booked for my parents' Bangalore visit. Beautiful 2BHK, fully furnished kitchen, doctor on call was a lifesaver. Highly recommended." },
  { id: "rv3", name: "Anil Mehta", initials: "AM", location: "Delhi", rating: 5, quote: "Excellent value for money. Clean, safe, peaceful — exactly what I needed for my extended work stay." },
  { id: "rv4", name: "Suresh Nair", initials: "SN", location: "Kerala", rating: 5, quote: "Perfect stay near the metro. The apartment was well-maintained, kitchen fully stocked. Will definitely book again on my next Bangalore trip." },
  { id: "rv5", name: "Deepa Rao", initials: "DR", location: "Chennai", rating: 5, quote: "Attended an exhibition at BIEC and this was the most convenient place to stay. Friendly owner, very clean rooms, great WiFi." },
  { id: "rv6", name: "Mohammed Irfan", initials: "MI", location: "Bangalore", rating: 5, quote: "Booked the 1BHK for a month. The location is unbeatable — 1 km from Chikkabidarakallu Metro. Housekeeping was regular and professional." },
  { id: "rv7", name: "Kavitha Reddy", initials: "KR", location: "Hyderabad", rating: 5, quote: "Came for a business trip and extended my stay by a week because I felt so at home. Quiet neighbourhood, spacious rooms, very reasonable pricing." },
  { id: "rv8", name: "Arjun Patel", initials: "AP", location: "Ahmedabad", rating: 5, quote: "The 3BHK was perfect for our family trip. Fully furnished, spacious living room, and the kitchen had everything we needed. Great experience!" },
  { id: "rv9", name: "Lakshmi Venkatesh", initials: "LV", location: "Mysore", rating: 5, quote: "Stayed for two weeks while attending a course nearby. Super clean, safe building with 24/7 security. The owner was very helpful and responsive." },
  { id: "rv10", name: "Ravi Chandran", initials: "RC", location: "Coimbatore", rating: 5, quote: "Comfortable A/C room at a very fair daily rate. Easy auto access to the metro. Would recommend to anyone visiting Bangalore for work or leisure." },
];

const Reviews = () => {
  const reviews = STATIC_REVIEWS;
  const avgRating = (
    reviews.reduce((s, r) => s + (r.rating || 0), 0) / reviews.length
  ).toFixed(1);

  return (
    <section
      id="reviews"
      className="py-20 md:py-28 px-5 md:px-10 bg-white relative"
      data-testid="reviews-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-3">
            <span className="h-[1px] w-6 bg-[#C8A97E]" />
            <span className="text-[10px] tracking-[0.28em] uppercase text-[#C8A97E] font-semibold">
              Verified Reviews
            </span>
            <span className="h-[1px] w-6 bg-[#C8A97E]" />
          </div>
          <h2 className="font-serif text-[40px] sm:text-[46px] font-semibold text-[#1A1A1A] leading-[1.1] mb-4">
            What our <em className="text-[#C8A97E] font-normal">guests say</em>
          </h2>
          <div className="inline-flex items-center gap-3 px-5 py-2 bg-[#FAF3E7] border border-[#E5D9BF] rounded-full">
            <div className="flex items-center gap-0.5">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star
                  key={i}
                  className={`w-4 h-4 ${
                    i <= Math.round(avgRating)
                      ? "fill-[#C8A97E] text-[#C8A97E]"
                      : "text-[#E5D9BF]"
                  }`}
                />
              ))}
            </div>
            <span className="text-[13px] font-semibold text-[#1A1A1A]">{avgRating}</span>
            <span className="text-[12px] text-[#666]">
              · {reviews.length} reviews
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <ReviewCard key={r.id} review={r} />
          ))}
        </div>
      </div>
    </section>
  );
};

const ReviewCard = ({ review }) => (
  <div
    className="bg-[#F9F7F3] border border-[#E5E0D8] rounded-[20px] p-7 hover:bg-white hover:border-[#C8A97E]/40 hover:shadow-[0_8px_28px_rgba(0,0,0,0.06)] transition-all relative"
    data-testid={`review-${review.id}`}
  >
    <Quote
      className="w-6 h-6 text-[#C8A97E]/30 absolute top-5 right-5"
      strokeWidth={1.5}
    />
    <div className="flex items-center gap-0.5 mb-4">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`w-3.5 h-3.5 ${
            i <= review.rating ? "fill-[#C8A97E] text-[#C8A97E]" : "text-[#E5D9BF]"
          }`}
        />
      ))}
    </div>
    <p className="text-[14px] text-[#444] leading-[1.7] mb-6 font-serif italic">
      "{review.quote}"
    </p>
    <div className="flex items-center gap-3 pt-4 border-t border-[#E5E0D8]">
      <div className="w-11 h-11 rounded-full bg-[#1A1A1A] text-[#C8A97E] flex items-center justify-center font-serif font-semibold text-[14px] flex-shrink-0">
        {review.initials || review.name?.[0] || "G"}
      </div>
      <div>
        <div className="text-[14px] font-semibold text-[#1A1A1A] leading-tight">
          {review.name}
        </div>
        {review.location && (
          <div className="text-[11px] text-[#9A9A9A] tracking-wide mt-0.5">
            {review.location}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default Reviews;
